import { render } from "./companyStatistics.vue?vue&type=template&id=09f9d618&scoped=true"
import script from "./companyStatistics.vue?vue&type=script&lang=js"
export * from "./companyStatistics.vue?vue&type=script&lang=js"

import "./companyStatistics.vue?vue&type=style&index=0&id=09f9d618&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09f9d618"

export default script